import React, { useState } from 'react';
import { sponsorsConfig } from '../../data/sponsors';

/**
 * Lista de logos de patrocinadores.
 *
 * `variant`:
 *  - 'stack': uma coluna, usada nas laterais do desktop.
 *  - 'grid': grade que se ajusta sozinha à largura disponível (2 colunas no
 *    celular, mais colunas conforme a tela cresce), usada abaixo do conteúdo.
 *
 * `sponsors` permite mostrar só um pedaço da lista — as laterais do desktop
 * dividem os patrocinadores entre esquerda e direita. Sem ela, mostra todos.
 *
 * O estilo vai inline porque o CSS do projeto (index.css) é escrito à mão e não
 * tem as classes de grid/responsividade do Tailwind.
 */
const AdSpace = ({ variant = 'stack', sponsors }) => {
  const [imageError, setImageError] = useState({});

  const sponsorsToShow = sponsors || sponsorsConfig.getActiveSponsors();

  const handleImageError = (sponsorId) => {
    setImageError((prev) => ({ ...prev, [sponsorId]: true }));
  };

  const handleSponsorClick = (sponsor) => {
    if (sponsor.url) {
      window.open(sponsor.url, '_blank', 'noopener,noreferrer');
    }
  };

  if (sponsorsToShow.length === 0) return null;

  const containerStyle =
    variant === 'grid'
      ? {
          display: 'grid',
          // auto-fit + minmax: o número de colunas vem da largura real do
          // espaço, sem precisar de breakpoint.
          gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
          gap: '0.75rem',
        }
      : { display: 'flex', flexDirection: 'column', gap: '0.75rem' };

  return (
    <div style={containerStyle}>
      {sponsorsToShow.map((sponsor) => (
        <div
          key={sponsor.id}
          className="bg-white border rounded-lg shadow"
          style={{
            height: '5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0.5rem',
            cursor: sponsor.url ? 'pointer' : 'default',
          }}
          onClick={() => handleSponsorClick(sponsor)}
          title={sponsor.description || sponsor.name}
        >
          {!imageError[sponsor.id] ? (
            <img
              src={sponsor.image}
              alt={sponsor.name}
              onError={() => handleImageError(sponsor.id)}
              loading="lazy"
              style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
            />
          ) : (
            // Sem imagem no servidor: o nome mantém o patrocinador visível e
            // clicável em vez de deixar um quadrado vazio.
            <span
              className="text-sm font-medium text-gray-700 text-center"
              style={{ lineHeight: 1.2 }}
            >
              {sponsor.name}
            </span>
          )}
        </div>
      ))}
    </div>
  );
};

export default AdSpace;
